import {useEffect} from "react";
import ReportCard from "../../../../../../components/reports/report-card.jsx";
import ReportUtils from "../../../../../../utils/report-utils.js";

const CardsContent = ({ data, boName }) => {
    const cards = data?.resume_cards?.[0];

    useEffect(() => {
        const values = [
            ["Total de ações", cards?.actions_total ?? 0],
            ["Despachos", cards?.dispatch_total ?? 0],
            ["Abordagens", cards?.encounter_total ?? 0],
            [`${boName}`, cards?.bos_total ?? 0],
            ["Detenções", cards?.detention_total ?? 0],
            ["Apreensões", cards?.apprehension_total ?? 0],
        ];

        ReportUtils.createExportableTable(["Descrição", "Quantidade"], values, "Cards");
    }, [cards]);

    return (
        <>
            <div className="flex flex-col">
                <div className="grid grid-cols-3">
                    <ReportCard
                        title="Total de ações"
                        idTitle={'Soma de todas as ações'}
                        value={cards?.actions_total ?? 0}
                    />

                    <ReportCard
                        title="Despachos"
                        value={cards?.dispatch_total ?? 0}
                    />

                    <ReportCard
                        title="Abordagens"
                        value={cards?.encounter_total ?? 0}
                    />
                </div>

                <div className="grid grid-cols-3">
                    <ReportCard
                        title={`${boName}`}
                        value={cards?.bos_total ?? 0}
                    />

                    <ReportCard
                        title="Detenções"
                        idTitle={'Detenções = Presos + Apreendidos'}
                        value={cards?.detention_total ?? 0}
                    />

                    <ReportCard
                        title="Apreensões"
                        value={cards?.apprehension_total ?? 0}
                    />
                </div>
            </div>

            <div className="chart-divisor"/>
        </>
    )
}

export default CardsContent;